/**
 * Robust native platform detection.
 * 
 * NO CACHING — always checks live because of race condition:
 * addJavascriptInterface() runs AFTER super.onCreate() starts page load,
 * so window.NativeAlarm might not exist when JS first runs.
 * 
 * On subsequent calls (useEffect, event handlers), the bridge IS ready.
 */

export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false;

  // Check 1: Our custom JavascriptInterface bridge (most reliable)
  if ('NativeAlarm' in window) return true;

  // Check 2: Capacitor's androidBridge
  if ('androidBridge' in window) return true;

  // Check 3: Capacitor.isNativePlatform()
  try {
    const { Capacitor } = require('@capacitor/core');
    if (Capacitor && Capacitor.isNativePlatform()) return true;
  } catch {}

  return false;
}
